import { CutRestrictionDTO } from 'src/types'
import { GridPinnedColumnFields } from '@microservices/wiskey-react-table-component'

export const transformFixRestrictions = (
  pinnedColumnsRestrictions: CutRestrictionDTO[]
): GridPinnedColumnFields => {
  return pinnedColumnsRestrictions?.reduce(
    (prev: GridPinnedColumnFields, current: CutRestrictionDTO) => {
      if (current.value === 'right' || current.value === 'left') {
        prev[current.value]?.push(current.fieldCode)
      }

      return prev
    },
    { right: [], left: [] }
  )
}
